"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { setConversionCritical } from "./tagGate";

/**
 * The ONLY router subscription behind the analytics gate.
 *
 * Conversion-critical pages (the checkout result page, or any URL carrying a
 * `track_id`) deliberately fire analytics on DOM-ready rather than waiting for the
 * browser to go idle. Deciding that needs `usePathname()` + `useSearchParams()`,
 * which every one of the eleven `useShouldFire()` consumers used to call for itself.
 *
 * `useSearchParams()` also opts its subtree into client-side rendering on every
 * search-param change when there is no `Suspense` boundary above it — which is why
 * this component is mounted inside one (see the layout) and why it renders nothing:
 * a CSR boundary around an empty component costs nothing.
 */
const TagGateSync = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const isCheckoutResultPage = !!pathname?.includes(
      PagesPaths.checkoutResult,
    );
    const hasTrackId = !!searchParams.get("track_id");
    setConversionCritical(isCheckoutResultPage || hasTrackId);
  }, [pathname, searchParams]);

  return null;
};

export default TagGateSync;
